<template>
  <div>
    <GmapMap
      :options="{
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false
      }"
      :center="center"
      :zoom="7"
      style="width:100%;  height: 400px;"
      ref="mapRef"
    >
      <GmapMarker
        :key="location.id + 'marker'"
        v-for="location in locations"
        :position="location.position"
        :clickable="true"
        :draggable="false"
        :icon="location.chosen ? icon : null"
        @mouseover="openInfoWindow(location)"
        @mouseout="closeInfoWindow(location)"
        @click="toggleAddLocation(location)"
      />
      <GmapInfoWindow
        :key="location.id + 'info'"
        v-for="location in locations"
        :options="location.infoWindow.options"
        :position="location.position"
        :opened="location.infoWindow.open"
        @closeclick="location.infoWindow.open = false"
      />
    </GmapMap>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";

export default {
  name: "compset-map",

  data() {
    return {
      map: null,
      center: { lat: 20, lng: 20 },
      icon: null
    };
  },

  computed: {
    google: gmapApi
  },

  props: ["locations"],

  mounted() {
    this.initMap();
  },

  methods: {
    initMap() {
      this.$refs.mapRef.$mapPromise.then(map => {
        this.icon = {
          url:
            "https://maps.gstatic.com/mapfiles/place_api/icons/restaurant-71.png",
          size: new this.google.maps.Size(71, 71),
          origin: new this.google.maps.Point(0, 0),
          anchor: new this.google.maps.Point(17, 34),
          scaledSize: new this.google.maps.Size(25, 25),
          zIndex: 3
        };
        this.map = map;
        this.displayLocations(true);

        this.$emit("map-ready", {
          google: this.google,
          map: this.map
        });
      });
    },

    displayLocations(includeChosen = false) {
      if (this.locations.length == 0) {
        return;
      }
      let bounds = new this.google.maps.LatLngBounds();
      this.locations.forEach(location => {
        if (!location.chosen || (includeChosen && location.chosen)) {
          bounds.extend(location.position);
        }
      });
      this.map.fitBounds(bounds);
    },

    toggleAddLocation(location) {
      this.$emit("location-clicked", location.id);
      return;
    },

    openInfoWindow(chosenLocation) {
      const locationIndex = this.locations.findIndex(
        location => location.id == chosenLocation.id
      );
      this.locations[locationIndex].infoWindow.open = true;
    },

    closeInfoWindow(chosenLocation) {
      const locationIndex = this.locations.findIndex(
        location => location.id == chosenLocation.id
      );
      this.locations[locationIndex].infoWindow.open = false;
    }
  }
};
</script>
